module.exports = __webpack_public_path__ + "static/media/bgLoginPage.92b76920.jpg";